import { Link } from "react-router-dom";
import MainHeading from "../../components/comman/MainHeading";
import { useCallback, useEffect, useState } from "react";
import { timeAgo } from "../../utility/CommonFunctions";
import { callApi } from "../../ApiHelper/ApiHelper";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { Spinner } from "reactstrap";
import { RoutesLink } from "../../ApiHelper/RoutesLink";

export default function Notifications() {
  const userDetails = useSelector((state) => state.root.userDetails);
  const dispatch = useDispatch();
  const [notificationData, setNotificationData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const breadcrumbArray = [{ title: "Notification", link: "" }];
  const [sendNotificationModal, setSendNotificationModal] = useState(false);
  const toggleSendNotificationModal = () =>
    setSendNotificationModal(!sendNotificationModal);

  const GetNotificationData = useCallback((pageNo) => {
    setIsLoading(true);
    let API = apiUrl?.get_notification + `?pageNumber=${pageNo}&pageSize=10`;
    callApi(API, { method: "GET" }).then((response) => {
      setIsLoading(false);
      if (response?.status) {
        const newNotifications = response?.data?.notification || [];
        if (newNotifications.length > 0) {
          setNotificationData((prevData) => [...prevData, ...newNotifications]);
        } else {
          setHasMore(false); // No more notifications to load
        }
      } else {
        setHasMore(false); // No more notifications to load
      }
    });
  }, []);

  const handleNavigateTabs = (item) => {
    // if (
    //   item?.notificationData?.key &&
    //   item?.notificationData?.key == "new_Userreport"
    // ) {
    //   dispatch(activeReportsTab(1));
    // }
    // if (
    //   item?.notificationData?.key &&
    //   item?.notificationData?.key == "new_Postreport"
    // ) {
    //   dispatch(activeReportsTab(2));
    // }
    // if (
    //   item?.notificationData?.key &&
    //   item?.notificationData?.key == "new_ambassador"
    // ) {
    //   dispatch(activeAmbassadorReqTab(1));
    // }
    // if (
    //   item?.notificationData?.key &&
    //   item?.notificationData?.key == "waiting_for_final_approval"
    // ) {
    //   dispatch(activeAmbassadorReqTab(3));
    // }
    // if (
    //   item?.notificationData?.key &&
    //   item?.notificationData?.key == "new_talent_user"
    // ) {
    //   dispatch(activeTalentRequestTab(2));
    // }
  };

  useEffect(() => {
    if (hasMore) {
      GetNotificationData(pageNo);
    }
  }, [pageNo, GetNotificationData, hasMore]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
          document.documentElement.offsetHeight - 1 &&
        !isLoading &&
        hasMore
      ) {
        setPageNo((prevPageNo) => prevPageNo + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isLoading, hasMore]);
  return (
    <>
      <div className="content">
        <MainHeading title={"Notifications"} />
        <div className="card mb-4">
          <div className="card-body mb-4 mb-xl-0">
            {notificationData && notificationData.length > 0
              ? notificationData.map((item, index) => (
                  <div
                    key={index}
                    className="p-2 pb-4 mb-4 font-13 border-bottom"
                  >
                    <Link
                      to={item?.data?.type && 
                        (
                          (item?.data?.type == "attendance" && RoutesLink?.ar_request_detail+`/${item?.data?.[item?.data?.type + "Id"]}`) ||
                          (item?.data?.type == "odRequest" && RoutesLink?.od_request_detail+`/${item?.data?.[item?.data?.type + "Id"]}`) ||
                          (item?.data?.type == "leave" && RoutesLink?.leave_detail+`/${item?.data?.[item?.data?.type + "Id"]}`) ||
                          (item?.data?.type == "purchaseRequest" && RoutesLink?.purchase_request_detail+`/${item?.data?.[item?.data?.type + "Id"]}`) ||
                          (item?.data?.type == "budgetRequest" && RoutesLink?.budget_requests && userDetails?.type === 2) ||
                          (item?.data?.type == "paymentTicket" && RoutesLink?.payment_tickets_details+`/${item?.data?.[item?.data?.type + "Id"]}`)
                        )
                      }
                      className="text-decoration-none text-black"
                    >
                      <div
                        className=" d-flex flex-column gap-2"
                        // onClick={() => handleNavigateTabs(item)}
                      >
                        <>
                          <div className="d-flex justify-content-between">
                            <h4
                              className="m-0 lead fw-semibold"
                              style={{ fontSize: "14px" }}
                            >
                              {item?.data?.title}
                            </h4>
                            <span className="text-muted fs-6">
                              {timeAgo(item?.createdAt)}
                            </span>
                          </div>

                          <p className="text-wrap fs-5 mb-0 lead ">
                            {item?.message}
                          </p>
                        </>
                      </div>
                    </Link>
                  </div>
                ))
              : !isLoading && (
                  <div className="d-flex justify-content-center font-14 text-muted p-3">
                    No Notifications
                  </div>
                )}
            {isLoading && (
              <div className="d-flex justify-content-center my-4">
                <Spinner color="primary" type="grow" />
                <Spinner color="primary" type="grow" />
                <Spinner color="primary" type="grow" />
                <Spinner color="primary" type="grow" />
                <Spinner color="primary" type="grow" />
              </div>
            )}
            {!hasMore && !isLoading && notificationData.length > 0 && (
              <p className="text-center m-0 text-muted p-0 fs-5 lead">
                No more notifications
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
